import { Typography } from '@mui/material';
import DashboardsList from '@src/main/ui/components/common/Dashboard/DashboardList/DashboardsList';
import DashboardsModal from '@src/main/ui/components/common/Dashboard/DashboardModal/DashboardModal';
import { useDashboardContext } from '@src/main/ui/providers/dashboard/DashboardContextProvider';
import { useUserContext } from '@src/main/ui/providers/user/UserContextProvider';
import { type FC } from 'react';

const Favorites: FC = () => {
  const { dashboards } = useDashboardContext();
  const { user } = useUserContext();

  const favoriteDashboards =
    dashboards && dashboards.filter((dashboard) => user?.favorites.includes(dashboard.id));

  return (
    <>
      <Typography variant="h3" sx={{ paddingRight: '40px' }}>
        Favorites
      </Typography>
      {dashboards && favoriteDashboards && favoriteDashboards.length === 0 ? (
        <Typography variant="h5" sx={{ marginTop: '30px', textAlign: 'center' }}>
          There&apos;s nothing here yet
        </Typography>
      ) : (
        <DashboardsList
          dashboards={favoriteDashboards || []}
          isExpandable={false}
          actions={{
            favorite: true,
            info: true,
          }}
        />
      )}
      <DashboardsModal />
    </>
  );
};

export default Favorites;
